import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import MyTasksIncidentsTable from "src/components/tables/MyTasksIncidentsTable.mobile";
import Loading from "src/components/Loading";
import { SearchUI } from "src/components/ui/Search";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItemsRequest } from "src/modules/spItems/api";
import { selectItems } from "src/modules/spItems/selectors";
import { addUsers } from "src/modules/users/actions";
import { selectCurrentUser } from "src/modules/users/selector";
import { RootState } from "src/store/rootReducer";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import AddIncident from "../addIncident/addIncident.mobile";
import {
  myTasksIncidentsStatusesListName,
  myTasksIncidentstListName,
  myTasksIncidentstWithRelationsListName,
  myTasksIncidentstPerPage,
} from "src/api/config/myTasksInc.config";
import {
  incStatus,
  incTypes
} from "src/api/config/systemSwitch";
import IncidentBaner from "./components/IncidentBaner";
import FiltersButton from "src/components/filters-button/filters-button";
import { IncidentsFilters } from "./IncidentsFilters.mobile";
import { MTFavoriteFiltersListName, myTasksLocationsListName } from "src/api/config/myTasksLists.config";
import moment from "moment";
import FilterActions from "src/components/filter-actions/filter-actions.mobile";

export function IncidentsPage() {
  const [exportData, setExportData] = useState<any>({});
  const [filters, setFilters] = useState<any>({});
  const [localFilters, setLocalFilters] = useState<any>({});
  const [searchQuery, setSearchQuery] = useState("");
  const [nextPage, setNextPage] = useState<any>(null);
  const [tempIncidents, setTempIncidents] = useState<any>([]);
  const [incidents, setIncidents] = useState<any>([]);
  const dispatch = useAppDispatch();
  const [customLoading, setCustomLoading] = useState(true);
  const [getIncidents, setGegIncidents] = useState(false);
  const location = useLocation();
  const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
  const currentUser = useAppSelector((state) => selectCurrentUser(state));
  const [lastInc, setLastInc] = useState<any>(null);
  const statuses: any = useAppSelector((state) => selectItems(state, myTasksIncidentsStatusesListName));
  const [fieldsFromExel, setFieldsFromExel] = useState([]);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [displayFilters, setDisplayFilters] = useState<any>({});
  const [displayFiltersStr, setDisplayFiltersStr] = useState<any>("");
  const [reRenderFilterSettings, setReRenderFilterSettings] = useState(false);
  const [filtersParams, setFiltersParams] = useState({});
  const [currentTypeInc, setCurrentTypeInc] = useState("Безопасность");
  const [defaultUserFilter, setDefaultUserFilter] = useState<any>(null);
  const collections: any = useAppSelector((state) => selectItems(state, myTasksLocationsListName));
  const [favoriteFilters, setFavoriteFilters] = useState<any[]>([]);
  const [favoriteFiltersDone, setFavoriteFiltersDone] = useState<boolean>(false);
  const [userFilterCheck, setUserFilterCheck] = useState(false);
  const [reRenderUserFilter, setReRenderUserFilter] = useState(null);
  const [incidentsFilter, setIncidentsFilter] = useState<any>(null);
  const [resetFilters, setResetFiters] = useState(false);

  function handleSearch(value: string) {
    setSearchQuery(value);
  }

  const isSelectedFilters = useMemo(() => {
      return (
          (filters.Status && filters.Status.length > 0) ||
          (filters.Location && filters.Location.length > 0) ||
          (filters.Department && filters.Department.length > 0) ||
          (filters.Region && filters.Region.length > 0) ||
          (filters.Trigger && filters.Trigger.length > 0) ||
          (filters.KPI && filters.KPI.length > 0) ||
          (filters.AuthorEmail && filters.AuthorEmail.trim() !== '') ||
          (filters.Editors && filters.Editors.trim() !== '') ||
          (filters.Tree && filters.Tree !== '') ||
          (filters.ActionsPlan && filters.ActionsPlan !== '') ||
          (filters.ProblemRepeat === true)
      )
  }, [filters]);

  // Эффект для начальной загрузки избранных фильтров
  useEffect(() => {
    if (!currentUser?.id) return;
    if (favoriteFiltersDone) return;

    getItemsRequest({
      listName: MTFavoriteFiltersListName,
      filters: { Author: currentUser.id, Type: "inc" }
    }).then(results => {
      setFavoriteFilters([...results.items]);
    }).then(() => setFavoriteFiltersDone(true));
  }, [currentUser]);

  useEffect(() => {
    if (!currentUser?.id) return;
    if (!favoriteFiltersDone && favoriteFilters.length === 0) return;
    if (Object.keys(filters).length > 0) return;

    const today = moment();
    const isMonday = today.isoWeekday() === 1;

    const defaultLocationIds = [
      ...(Array.isArray(currentUser.isLocationAdminMyTasks)
        ? currentUser.isLocationAdminMyTasks
        : []),
      ...(Array.isArray(currentUser.isLocationEditorMyTasks)
        ? currentUser.isLocationEditorMyTasks
        : []),
    ];

    const uniqueLocationIds = _.uniq(defaultLocationIds);

    const defaultFilters = {
      DateIncidents: {
        start: isMonday
          ? moment().subtract(1, "week").startOf("isoWeek").format("YYYY-MM-DDT00:00:00")
          : moment().startOf("isoWeek").format("YYYY-MM-DDT00:00:00"),
        end: isMonday
          ? moment().subtract(1, "week").endOf("isoWeek").format("YYYY-MM-DDT23:59:59")
          : moment().endOf("isoWeek").format("YYYY-MM-DDT23:59:59"),
      },
      TypeIncident: incTypes.safe,
      ...(uniqueLocationIds.length > 0 && {
        Location: uniqueLocationIds,
      })
    };

    const defaultFiltersFavorite = favoriteFilters.find((item: any) => item.DefaultFilter === true);

    let finalFilters;

    if (defaultFiltersFavorite) {
      const parsedFavorite = JSON.parse(defaultFiltersFavorite.MTFilters);
      finalFilters = { ...parsedFavorite };

      setFilters({ ...defaultFilters, ...parsedFavorite });
    } else {
      setFilters(defaultFilters);
    }

    
    setLocalFilters({});
    setDisplayFilters({});
    setFiltersParams({});
    // setCurrentTypeInc(`Безопасность_${Math.random()}`);
    setCurrentTypeInc(defaultUserFilter && `${JSON.parse(defaultUserFilter.DisplayFilters)['TypeIncident']}_${Math.random()}` || `Безопасность_${Math.random()}`);
    setGegIncidents(false);
  }, [currentUser, collections, favoriteFiltersDone, favoriteFilters]);

  //Получение инцидента для плашки
  useEffect(() => {
    getItemsRequest({
      listName: myTasksIncidentstListName,
      rowLimit: 1,
      filters: { Questions: ["LTI-травма с потерей трудоспособности"] },
      nextPage,
      sortOrder: { name: "DateIncidents2", desc: true },
    }).then((results) => {
      const lastIncResults = [...results.items];
      if (lastIncResults.length > 0) {
        setLastInc(lastIncResults[0]);
      }
    });
  }, [currentUser]);

  //Получение инцидентов после изменения фильтров
  useEffect(() => {
    const controller = new AbortController();
    let canceled = false;
    if (!getIncidents && Object.keys(filters).length > 0) {

      setTempIncidents([]);
      setIncidents([]);
      setCustomLoading(true);
      getItemsRequest({
        listName: myTasksIncidentstWithRelationsListName,
        rowLimit: myTasksIncidentstPerPage,
        filters,
        sortOrder: { name: "DateIncidents", desc: true },
        signal: controller.signal,
      }).then((results: any) => {
        if (canceled) return;
        const { items, nextPage } = results;
        if (items.length > 0) {
          let incIds: string[] = [];
          let emails: any = [];
          let requests5Way: any = [];
          items.map((item: any) => {
            if (item.ResponsibleEmail) {
              emails = [...emails, item.ResponsibleEmail.toLowerCase()];
            }
            if (item.AuthorEmail) {
              emails = [...emails, item.AuthorEmail.toLowerCase()];
            }
          });
          dispatch(addUsers([..._.uniqWith(emails, _.isEqual)]));

          setTempIncidents([...items]);
          setGegIncidents(true);
          if (nextPage) {
            setNextPage(nextPage);
          } else {
            setNextPage(false);
          }
        } else {
          setGegIncidents(true);
          setNextPage(false);
          setTempIncidents([]);
          setIncidents([]);
        }
      }).catch((error: any) => {
        if (canceled || error.name === 'AbortError' || error.name === 'CanceledError') return;
        console.log("getItemsRequest error:", error);
      });
    }
    return () => {
      canceled = true;
      controller.abort();
    };
  }, [filters]);

  //Получение инцидентов по nextPage
  useEffect(() => {
    if (nextPage && getIncidents) {
      getItemsRequest({
        listName: myTasksIncidentstWithRelationsListName,
        rowLimit: myTasksIncidentstPerPage,
        filters,
        nextPage,
        sortOrder: { name: "DateIncidents", desc: true },
      }).then((results: any) => {
        const { items, nextPage } = results;

        let emails: any = [];

        items.map((item: any) => {
          if (item.ResponsibleEmail) {
            emails = [...emails, item.ResponsibleEmail.toLowerCase()];
          }
          if (item.AuthorEmail) {
            emails = [...emails, item.AuthorEmail.toLowerCase()];
          }
        });
        dispatch(addUsers([..._.uniqWith(emails, _.isEqual)]));

        setTempIncidents((prevState: any) => [...prevState, ...items]);
        if (nextPage) {
          setNextPage(nextPage);
        } else {
          setNextPage(false);
        }
      });
    }
  }, [nextPage]);

  useEffect(() => {
    if (tempIncidents.length > 0) {
      let incWithQuestions: any = [];
      tempIncidents.forEach((incItem: any) => {
        if (incItem.Questions) {
          incWithQuestions = [
            ...incWithQuestions,
            { ...incItem, ...JSON.parse(incItem.Questions) },
          ];
        }
      });
      let localTempInc: any = [...incWithQuestions];
      if (Object.keys(localFilters).length > 0) {
        Object.keys(localFilters).forEach((key) => {
          if (
            key !== "QAIncidentListBlock" &&
            key !== "QAIncidentList" &&
            key !== "MIncDowntime" &&
            key !== "MIncEmergencyPurchaseCost" &&
            key !== "MIncQuantityOfLostProduct" &&
            key !== "TimeIncident" &&
            key !== "StatusActions" &&
            key !== "EnvNRelated" &&
            key !== "EnvIncEquipRelated" &&
            key !== "EnvIncDocRelated" &&
            key !== "EnvIncControlParam" &&
            key !== "EnvIncValueEnvironment"
          ) {
            localTempInc = localTempInc.filter((localInc: any) => {
              if (Array.isArray(localFilters[key])) {
                return localFilters[key].some(
                  (localFilter: any) =>
                    localInc.Questions &&
                    localInc.Questions.indexOf(localFilter.name.trim()) !== -1
                );
              }
            });
          } else if (key === "TimeIncident") {
            localTempInc = localTempInc.filter(
              (localItem: any) =>
                localItem[key] &&
                Number(localItem[key].replace(":", "")) >
                localFilters[key]["fromTime"] &&
                Number(localItem.TimeIncident.replace(":", "")) <
                localFilters[key]["beforeTime"]
            );
          } else if (
            key === "QAIncidentListBlock" ||
            key === "QAIncidentList" ||
            key === "MIncDowntime" ||
            key === "MIncEmergencyPurchaseCost" ||
            key === "MIncQuantityOfLostProduct"
          ) {
            localTempInc = localTempInc.filter(
              (localItem: any) =>
                localItem.Questions &&
                Number(JSON.parse(localItem.Questions)[key]) >
                localFilters[key]["fromNumber"] &&
                localItem.Questions &&
                Number(JSON.parse(localItem.Questions)[key]) <
                localFilters[key]["beforeNumber"]
            );
          } else if (key === "StatusActions") {
            localTempInc = localTempInc.filter((localInc: any) => {
              if (Array.isArray(localFilters[key])) {
                return localFilters[key].some(
                  (localFilter: any) =>
                    localFilter.name === localInc.actionsIncStatus.name
                );
              }
            });
          } else if (
            key === "EnvNRelated" ||
            key === "EnvIncEquipRelated" ||
            key === "EnvIncDocRelated" ||
            key === "EnvIncControlParam" ||
            key === "EnvIncValueEnvironment"
          ) {
            localTempInc = localTempInc.filter((localInc: any) => {
              if (Array.isArray(localFilters[key])) {
                return localFilters[key].some(
                  (localFilter: any) =>
                    Array.isArray(localInc[key]) &&
                    localInc[key].join(",").indexOf(localFilter.name.trim()) !==
                    -1
                );
              }
            });
          }
        });
      }
      if (
        filters["Questions"] &&
        filters["Questions"].some(
          (question: any) => question.indexOf("Инцидент") !== -1
        )
      ) {
        setIncidents([
          ..._.uniqWith(
            localTempInc.filter(
              (inc: any) => inc.IncidentOption === "Инцидент"
            ),
            _.isEqual
          ),
        ]);
      } else {
        setIncidents([
          ..._.uniqWith(
            localTempInc.filter(
              (inc: any) => inc.IncidentOption === "Несоответствие"
            ),
            _.isEqual
          ),
        ]);
      }
    }
  }, [tempIncidents]);

  useEffect(() => {
    const incCardID = new URLSearchParams(location.search).get("incidentCardMobile");
    if (
      localStorage.getItem("NEW_INC") &&
      !localStorage.getItem("default5WayCardDataInc")
    ) {
      localStorage.setItem("NEW_INC", "");
      localStorage.setItem("UPDATE_STATUS_INC", "");
      setFilters({ ...filters });
      setGegIncidents(false);
    }
  }, [location]);

  useEffect(() => {
    if (!nextPage && getIncidents) {
      setCustomLoading(false);
    }
  }, [incidents]);

  useEffect(() => {
    let tempStr = "";
    Object.keys(displayFilters).map((key: string, idx: number) => {
      if (idx <= 3) {
        if (Array.isArray(displayFilters[key])) {
          displayFilters[key].map((item: string, idx: number) => {
            if (displayFilters[key].length - 1 === idx) {
              tempStr += item
            } else {
              tempStr += `${item}, `
            }
          })
        } else {
          tempStr += `${displayFilters[key]}`
        }
        tempStr += ', '
      }
    });
    tempStr = tempStr.slice(0, -2);
    if (Object.keys(displayFilters).length > 4) {
      tempStr += `...ещё ${Object.keys(displayFilters).length - 4}`
    }
    setDisplayFiltersStr(tempStr);
  }, [displayFilters]);

  const extraCompareData = useMemo(() => {
    const today = moment();
    const isMonday = today.isoWeekday() === 1;
    const defaultDateRange = {
      startDate: isMonday
        ? moment().subtract(1, "weeks").startOf("isoWeek").format('YYYY-MM-DDT00:00:00')
        : moment().startOf("isoWeek").format('YYYY-MM-DDT00:00:00'),
      endDate: isMonday
        ? moment().subtract(1, "weeks").endOf("isoWeek").format('YYYY-MM-DDT23:59:59')
        : moment().endOf("isoWeek").format('YYYY-MM-DDT23:59:59'),
    };
    const result: any = {};
    if (incidentsFilter?.DateIncidents && !_.isEqual(incidentsFilter.DateIncidents, defaultDateRange)) {
      result.DateIncidents = incidentsFilter.DateIncidents;
    }
    if (incidentsFilter?.DateIncidents2) {
      result.DateIncidents2 = incidentsFilter.DateIncidents2;
    }
    if (incidentsFilter?.TimeIncident) {
      result.TimeIncident = incidentsFilter.TimeIncident;
    }
    return Object.keys(result).length > 0 ? result : undefined;
  }, [incidentsFilter]);

  const handleResetAllFilters = () => {
    const defaultFiltersFavorite = favoriteFilters.find((item: any) => item.DefaultFilter === true);
    setDefaultUserFilter(defaultFiltersFavorite || null);
    setLocalFilters({});
    setFilters({});
    setIncidentsFilter(null);
    setDisplayFilters({});
    setFiltersParams({});
    setCurrentTypeInc(defaultFiltersFavorite && `${JSON.parse(defaultFiltersFavorite.DisplayFilters)['TypeIncident']}_${Math.random()}` || `Безопасность_${Math.random()}`);
    setResetFiters(!resetFilters);
    setGegIncidents(false);
  }

  return (
    <FlexRow className="scrollbar-none scrollbar-w-2 scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] h-screen overflow-y-auto">
      <FlexCol className="bg-white sticky-custom border-r w-80 text-[14px] text-[#8899A8] relative scrollbar scrollbar-w-2  scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB] max-h-screen hidden">
        <FlexCol className="max-w-[320px] overflow-y-auto scrollbar scrollbar-w-2 scrollbar-h-2 scrollbar-thumb-rounded-md scrollbar-thumb-[#D1D5DB]">
          <FilterActions
            isOpen={isOpenFilter}
            onClose={() => setIsOpenFilter(false)}
            onResetFilters={handleResetAllFilters}
            filters={filters}
            displayFilters={displayFilters}
            reRenderFilterSettings={reRenderFilterSettings}
            setReRenderFilterSettings={setReRenderFilterSettings}
            filtersParams={filtersParams}
            favoriteType="inc"
            favoriteListQuestions={myTasksIncidentstWithRelationsListName}
            reRenderTableFlag={setGegIncidents}
            setFiltersParams={setFiltersParams}
            setDefaultUserFilter={setDefaultUserFilter}
            setUserFilterCheck={setUserFilterCheck}
            userFilterCheck={userFilterCheck}
            setReRenderUserFilter={setReRenderUserFilter}
            favoriteFilters={favoriteFilters}
            setFavoriteFilters={setFavoriteFilters}
            extraCompareData={extraCompareData}
          >
            <IncidentsFilters
              onClose={() => setIsOpenFilter(false)}
              filters={filters}
              setGegIncidents={setGegIncidents}
              setFilters={setFilters}
              searchQuery={searchQuery}
              setLocalFilters={setLocalFilters}
              setFieldsFromExel={setFieldsFromExel}
              displayFilters={displayFilters}
              setDisplayFilters={setDisplayFilters}
              filtersParams={filtersParams}
              setFiltersParams={setFiltersParams}
              setCurrentTypeInc={setCurrentTypeInc}
              currentTypeInc={currentTypeInc}
              defaultUserFilter={defaultUserFilter}
              setDefaultUserFilter={setDefaultUserFilter}
              reRenderFilterSettings={reRenderFilterSettings}
              userFilterCheck={userFilterCheck}
              reRenderUserFilter={reRenderUserFilter}
              favoriteFilters={favoriteFilters}
              setFavoriteFilters={setFavoriteFilters}
              handleResetAllFilters={handleResetAllFilters}
              setIncidentsFilter={setIncidentsFilter}
              incidentsFilter={incidentsFilter}
              setResetFiters={setResetFiters}
              resetFilters={resetFilters}
            />
          </FilterActions>
        </FlexCol>
      </FlexCol>
      <FlexCol className="grow w-[calc(100%-320px)]">
        <FlexCol className="w-full">
          <FlexRow className="justify-between items-center shrink-0">
            <FlexCol>
              <nav className="flex justify-between w-full" aria-label="Breadcrumb">
                <FlexCol className="grow">
                  <ol className="inline-flex items-center gap-2">
                    <li className="inline-flex items-center" aria-current="page">
                      <div className="inline-flex items-center space-x-2 text-base font-medium cursor-pointer">
                        {/* <span>Инциденты и несоответствия</span> */}
                        {filters.TypeIncident === incTypes.safe && !filters.Questions && <span>Инциденты и несоответствия</span>}
                      </div>
                    </li>
                    {filters.TypeIncident &&
                      filters.Questions &&
                      (((filters.Questions.some(
                        (item: any) => item.indexOf("Инцидент") !== -1
                      ) ||
                        filters.Questions.some(
                        (item: any) => item.indexOf("Несоответствие") !== -1)
                      ) &&
                        filters.TypeIncident !== incTypes.q) ||
                        (filters.TypeIncident === incTypes.q &&
                          (filters.Questions.some(
                            (item: any) => item.indexOf("Инцидент в процессе") !== -1) ||
                            filters.Questions.some(
                                (item: any) => item.indexOf("Инцидент по качеству") !== -1) ||
                            filters.Questions.some(
                                (item: any) => item.indexOf("Несоответствие") !== -1)))) && (
                        <>
                          <li className="inline-flex items-center" aria-current="page">
                            <div className="inline-flex items-center space-x-2 text-base font-medium">
                              <>
                                {filters.Questions.some(
                                    (item: any) => item.indexOf("Инцидент") !== -1
                                ) && (
                                  <>
                                    {filters.TypeIncident === incTypes.safe && (
                                      <>Инцидент по безопасности</>
                                    )}
                                    {filters.TypeIncident === incTypes.e && (
                                        <>Инцидент по экологии</>
                                    )}
                                    {filters.TypeIncident === incTypes.q && (
                                      <>
                                        {filters.Questions.some(
                                          (item: any) => item.indexOf("Инцидент в процессе") !== -1
                                        ) && <>Инцидент в процессе</>}
                                        {filters.Questions.some(
                                          (item: any) => item.indexOf("Инцидент по качеству") !== -1
                                        ) && <>Инцидент по качеству</>}
                                      </>
                                    )}
                                    {filters.TypeIncident === incTypes.m && (
                                        <>Инцидент по техобслуживанию</>
                                    )}
                                  </>
                                )}
                                {filters.Questions.some(
                                    (item: any) => item.indexOf("Несоответствие") !== -1) && (
                                  <>
                                    {filters.TypeIncident === incTypes.safe && (
                                        <>Несоответствия по безопасности</>
                                    )}
                                    {filters.TypeIncident === incTypes.e && (
                                        <>Несоответствия по экологии</>
                                    )}
                                    {filters.TypeIncident === incTypes.q && (
                                        <>Несоответствия по качеству</>
                                    )}
                                    {filters.TypeIncident === incTypes.m && (
                                        <>Несоответствия по техобслуживанию</>
                                    )}
                                  </>
                                )}
                              </>
                            </div>
                          </li>
                        </>
                      )}
                  </ol>
                </FlexCol>
              </nav>
            </FlexCol>
            {lastInc &&
              filters.TypeIncident &&
              filters.Questions &&
              filters.Questions.some(
                (item: any) => item.indexOf("Инцидент") !== -1
            ) &&
              filters.TypeIncident === 1 && (
              <IncidentBaner lastInc={lastInc} />
            )}
          </FlexRow>
          <FlexCol className="pt-[16px] pb-[16px] gap-y-[16px]">
            <FlexRow className="gap-x-2.5">
              <FlexCol className="grow">
                <SearchUI
                  placeholder="Ключевая фраза"
                  defaultValue={searchQuery}
                  onClick={handleSearch}
                  inputClass="text-[13px]"
                />
              </FlexCol>
              <FlexCol className="shring-0">
                <FiltersButton isSelectedFilters={isSelectedFilters} onOpenFilters={() => { setIsOpenFilter(true); setReRenderUserFilter(Math.random()); }}/>
              </FlexCol>
            </FlexRow>
              <FlexCol className="shring-0">
                {(currentUser.isLocationEditorMyTasks ||
                  currentUser.isAdmin ||
                  currentUser.isLocationAdminMyTasks) && (
                  <AddIncident zIndex={70} />
                )}
              </FlexCol>
          </FlexCol>
          <FlexRow>
            {(customLoading || statusUsers === "LOADING") && incidents.length === 0 ? (
              <FlexCol className="w-full py-10 items-center justify-center gap-3">
                <Loading />
              </FlexCol>
            ) : (
              <MyTasksIncidentsTable
                data={incidents}
                setExportData={setExportData}
                customLoading={customLoading || statusUsers === "LOADING"}
                statuses={statuses}
                fieldsFromExel={fieldsFromExel}
                typeN={
                  filters.Questions &&
                  filters.Questions.length > 0 &&
                  filters.Questions.some((item: any) => item.indexOf("Несоответствие") !== -1)
                }
              />
            )}
          </FlexRow>
        </FlexCol>
      </FlexCol>
    </FlexRow>
  );
}
